// extracted by mini-css-extract-plugin
module.exports = {"menu-button":"MenuButton_menu-button__3pgJf","menu-button__cross":"MenuButton_menu-button__cross__15YBR"};